import $ from "jquery";
import "slick-carousel";

var carousel = document.querySelector("[data-carousel-name=achievements]");
var carouselArrows = document.querySelector("[data-carousel-arrows=true]");

$(carousel).slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  infinite: false,
  prevArrow: ".arrow-back",
  nextArrow: ".arrow-forward",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
      },
    },
  ],
});
